export default __webpack_public_path__ + "static/media/NewChevronRightIcon.1010356b.svg";